export const getJSON = (response) => response.json();

export const logError = (error) => console.log('An error occurred.', error);
